module.exports = __webpack_public_path__ + "static/media/cuisine.cd728ae0.jpg";